import { motion } from 'framer-motion';
import type { QuestionDefinition } from '../../../../types/checkin';

interface EmojiScaleQuestionProps {
  question: QuestionDefinition;
  value: number | undefined;
  onChange: (value: number) => void;
}

const EMOJIS = ['😫', '😕', '😐', '🙂', '😊'];

export function EmojiScaleQuestion({
  value,
  onChange,
}: EmojiScaleQuestionProps) {
  return (
    <div className="space-y-4">
      <div className="flex justify-between gap-3">
        {EMOJIS.map((emoji, index) => {
          const scaleValue = index + 1;
          const isSelected = value === scaleValue;

          return (
            <motion.button
              key={scaleValue}
              onClick={() => onChange(scaleValue)}
              className={`
                relative flex-1 aspect-square flex items-center justify-center
                text-7xl rounded-2xl border-4 transition-all duration-200
                ${
                  isSelected
                    ? 'border-accent-500 bg-accent-50 dark:bg-accent-900/20 scale-105 shadow-lg'
                    : 'border-surface-200 dark:border-surface-700 hover:border-surface-300 dark:hover:border-surface-600 hover:scale-105'
                }
              `}
              whileTap={{ scale: 0.95 }}
              transition={{ type: 'spring', stiffness: 300, damping: 20 }}
            >
              {emoji}
            </motion.button>
          );
        })}
      </div>
    </div>
  );
}
